export const isValidDateFormat = (date: string): boolean => {
  // Check basic format DD.MM.YYYY
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(date)) {
    return false;
  }

  // Extract day, month, year
  const [day, month, year] = date.split('.').map(Number);

  // Check valid ranges
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;
  if (year < 1900 || year > new Date().getFullYear()) return false;

  // Check specific month lengths
  const daysInMonth = new Date(year, month, 0).getDate();
  if (day > daysInMonth) return false;

  return true;
}; 